import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { SelectSearchOption } from '@shared/ui/fields'

import { faFlagPennant } from '@fortawesome/pro-solid-svg-icons'

import { useListsStore } from '@shared/model'

import { useTutorKanbanStore } from './store'

interface TutorKanbanSelectPriorityReturn {
  refOptions: ComputedRef<SelectSearchOption<number | null>[]>
  refCurrent: ComputedRef<SelectSearchOption<number | null> | null>
  handleChange: (option: SelectSearchOption<string | number | null>) => void
}

const INITIAL_OPTION: SelectSearchOption<number | null> = {
  id: 0,
  value: null,
  text: '--- Not selected ---',
  selected: true,
}

export const useTutorKanbanSelectPriority = (): TutorKanbanSelectPriorityReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const listsStore = useListsStore()

  const refList = computed<Record<string, number>>(() => listsStore.getLists?.kanban_priority ?? {})

  const refOptions = computed<SelectSearchOption<number | null>[]>(() => {
    const current = tutorKanbanStore.getTutor?.kanban_priority ?? null

    const options: SelectSearchOption<number | null>[] = Object.entries(refList.value).map(([text, value]) => ({
      id: value,
      value,
      text,
      icon: faFlagPennant,
      colorIcon: text,
      selected: current !== null && value === current,
    }))

    return [INITIAL_OPTION, ...options]
  })

  const refCurrent = computed<SelectSearchOption<number | null> | null>(() => {
    const current = tutorKanbanStore.getTutor?.kanban_priority ?? null
    return refOptions.value.find(option => option.value === current) ?? null
  })

  const handleChange = (option: SelectSearchOption<string | number | null>): void => {
    tutorKanbanStore.setTutorPriority(Number(option.value))
  }

  return {
    refOptions,
    refCurrent,
    handleChange,
  }
}
